module.exports = __webpack_public_path__ + "img/edge_divers_specialite.ce112943.svg";